import React, { useEffect, useState } from 'react';
import mediaApi from '../api/mediaApi';

function MediaTest() {
  const [mediaFiles, setMediaFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('MediaTest component mounted');
    
    const fetchMedia = async () => {
      try {
        console.log('Fetching media files...');
        const response = await mediaApi.getAllMedia();
        console.log('Media API response:', response);
        setMediaFiles(response.files || []);
      } catch (err) {
        console.error('Error fetching media:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMedia();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div style={{ padding: '20px' }}>
      <h1>Media Test Component</h1>
      <p>Found {mediaFiles.length} media files</p>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '16px', marginTop: '20px' }}>
        {mediaFiles.map((file) => {
          const imageUrl = mediaApi.getFileUrl(file.filename, true);
          console.log(`Image URL for ${file.filename}:`, imageUrl);
          
          return (
            <div key={file.id} style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '8px' }}>
              <h3>{file.originalName}</h3>
              <p>URL: {imageUrl}</p>
              {file.mimeType.startsWith('image/') && (
                <img 
                  src={imageUrl}
                  alt={file.originalName}
                  style={{ 
                    width: '100%', 
                    height: '150px', 
                    objectFit: 'cover',
                    border: '2px solid red'  // Red border to see if image loads
                  }}
                  onLoad={() => console.log(`Image loaded successfully: ${file.filename}`)}
                  onError={(e) => {
                    console.error(`Image failed to load: ${file.filename}`, e);
                    console.error('Failed URL:', imageUrl);
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MediaTest;